export default "__VITE_ASSET__BfJNAFM6__"